import { render, staticRenderFns } from "./ModalAdds.vue?vue&type=template&id=2e30ee52"
import script from "./ModalAdds.vue?vue&type=script&lang=js"
export * from "./ModalAdds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports